import React from 'react';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';
import VideoModal, { IVideoModalProps } from '../VideoModal';

export interface IContentTileVideoProps extends IBaseElementProps {
	tileHeading?: string;
	tileVideo?: IVideoModalProps;
}

const ContentTileVideo: React.FC<IContentTileVideoProps> = ({
	tileHeading,
	tileVideo,
}) => (
	<div className="card rounded-5 border-0 position-relative">
		{tileVideo && (
			<VideoModal className="video video--poster rounded-5" {...tileVideo} />
		)}
		{tileHeading && (
			<h4 className="card-title text-white position-absolute bottom-0 px-4 pt-5 pb-4">
				{tileHeading}
			</h4>
		)}
	</div>
);

export default ContentTileVideo;
